exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-modal .uk-modal-dialog[data-v-6c8dde74] {\n  width: 800px;\n}\n.company[data-v-6c8dde74] {\n  padding: 20px;\n  font-size: 1.2em;\n}", ""]);

// exports
